import BackendApiClient from '../api/BackendApiClient';
import { AppWebViewMessageTypes } from '../exports/Constants';
import WebViewResource from '../resources/WebViewResource';

const TOKEN_KEY = 'AMIGO_FRONTEND_WEB_API_AUTH_TOKEN';

class AuthorizationTokenStorage {
  getToken = (): null | string => localStorage.getItem(TOKEN_KEY);

  saveToken = async (token: string): Promise<boolean> =>
    new Promise((resolve) => {
      localStorage.setItem(TOKEN_KEY, token);
      WebViewResource.sendMessage(AppWebViewMessageTypes.AuthToken, {
        token,
      });
      resolve(true);
    });

  deleteToken = (): void => {
    localStorage.removeItem(TOKEN_KEY);
    BackendApiClient.deleteAuthToken();
    WebViewResource.sendMessage(AppWebViewMessageTypes.AuthToken, {
      token: null,
    });
  };
}

export default new AuthorizationTokenStorage();
